import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const pageTitle = "Emergency Passport Billings, MT — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Fast Passport Center provides emergency, expedited, and same-day passport services in Billings, Montana. Serving Yellowstone County, Laurel, Hardin, and surrounding areas. As fast as 24 hours — no Denver agency trip needed.";

const billingsFaqs = [
  { q: "How do I get an expedited passport in Billings, Montana?", a: "Billings residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agency is in Denver, 450+ miles south via I-25." },
  { q: "Where is the nearest passport agency to Billings?", a: "The Denver Regional Passport Agency (3151 S Vaughn Way, Suite 600, Aurora, CO 80014) is approximately 450 miles south of Billings via I-25. It requires an appointment for emergencies only. Fast Passport Center eliminates that trip." },
];

export default function BillingsPage() {
  return (
    <>
      <CitySEOHead
        city="Billings"
        state="Montana"
        stateAbbr="MT"
        route="/cities/billings"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Billings, Montana"
        geoPosition="45.7833;-108.5007"
        keywords="expedited passport Billings, emergency passport Billings MT, same day passport Billings, fast passport Montana, passport renewal Billings, Yellowstone County passport"
        faqs={billingsFaqs}
        servicesSchema={[]}
        statePageName="Montana"
        statePageRoute="/states/montana"
        lastModified="2026-06-09"
        serviceAreaDesc="Expedited and emergency passport services for Billings, MT and Yellowstone County. As fast as 24 hours. No Denver agency trip needed."
      />

      <div className="min-h-screen bg-white">
        <HeroSection />
        <StickyNav />
        <ProcessingTimeSection />
        <LocalAreaSection />
        <ServicesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <AcceptanceFacilitiesSection />
        <ComparisonSection />
        <MistakesSection />
        <FAQSection />
        <HelpfulResourcesSection />
        <FinalCTA />
      </div>
    </>
  );
}